import {Component} from '@angular/core';
import {BaseComponent} from '@shared/lib/components/base.component';

@Component({
  selector: 'u-technology-cn',
  templateUrl: './technology-cn.component.html',
  styleUrls: ['./technology-cn.component.scss'],
  providers: [{provide: BaseComponent, useExisting: TechnologyCnComponent}]
})
export class TechnologyCnComponent extends BaseComponent {
  src = 'technology-cn';
  map = {
    heading: 'heading',
    text: 'text',
    icon1: 'icon1',
    icon2: 'icon2',
    disclaimer: 'disclaimer',
    technologies: [
      {
        image: 'technologies.0.image',
        alt: 'technologies.0.alt',
        heading1: 'technologies.0.heading1',
        heading2: 'technologies.0.heading2',
        text1: 'technologies.0.text1',
        text2: 'technologies.0.text2',
        text3: 'technologies.0.text3',
        linkText: 'technologies.0.linkText',
        linkUrl: 'technologies.0.linkUrl',
        target: 'technologies.0.target'
      }
    ],
    projects: [
      {
        heading: 'projects.0.heading',
        image: 'projects.0.image',
        alt: 'projects.0.alt',
        text1: 'projects.0.text1',
      },
      {
        heading: 'projects.1.heading',
        image: 'projects.1.image',
        alt: 'projects.1.alt',
        text1: 'projects.1.text1',
      },
      {
        heading: 'projects.2.heading',
        image: 'projects.2.image',
        alt: 'projects.2.alt',
        text1: 'projects.2.text1',
      },
    ]
  };

  // eslint-disable-next-line
  ngOnInit() {
    const hasScienceDisclaimer = this.localeService.getLocaleObject().hasScienceDisclaimer;
    const hasIncelligence = this.localeService.getLocaleObject().hasIncelligence;
    const hasHybridTechnology = this.localeService.getLocaleObject().hasHybridTechnology;
    const hasOlivol = this.localeService.getLocaleObject().hasOlivol;
    if (!hasScienceDisclaimer) {
      delete this.map.disclaimer;
    }
    if (!hasIncelligence) {
      delete this.map.technologies[0];
    }
    if (!hasHybridTechnology) {
      delete this.map.technologies[1];
    }
    if (!hasOlivol) {
      delete this.map.technologies[2];
    }
    this.map.technologies = this.map.technologies.filter(n => n); // remove empty elements from array
    if (!hasIncelligence && !hasHybridTechnology && !hasOlivol) {
      this.supportedLocale = false;
    }
    super.ngOnInit();
  }
}
